module.exports = __webpack_public_path__ + "static/img/device.a95451c.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/device.png
// module id = agjj
// module chunks = 1